import React from 'react';
import { useTheme } from '@material-ui/core';
import { animated, useTransition, to } from 'react-spring';

const fromLeaveTransition = ({ endAngle }) => ({
  // enter from 360° if end angle is > 180°
  startAngle: endAngle > Math.PI ? 2 * Math.PI : 0,
  endAngle: endAngle > Math.PI ? 2 * Math.PI : 0,
  opacity: 0,
});
const enterUpdateTransition = ({ startAngle, endAngle }) => ({
  startAngle,
  endAngle,
  opacity: 1,
});

export default function AnimatedPie({
  animate,
  arcs,
  path,
  getKey,
  getColor,
  onClickDatum,
  showTooltip = null,
  hideTooltip = null,
  showLabel,
}) {
  const transitions = useTransition(arcs, {
    from: animate ? fromLeaveTransition : enterUpdateTransition,
    enter: enterUpdateTransition,
    update: enterUpdateTransition,
    leave: animate ? fromLeaveTransition : enterUpdateTransition,
    keys: getKey,
  });
  const theme = useTheme();

  return (
    <>
      {transitions((props, arc, { key }) => {
        const [centroidX, centroidY] = path.centroid(arc);
        const hasSpaceForLabel = arc.endAngle - arc.startAngle >= 0.25;
        const {
          data: { tooltip },
        } = arc;

        return (
          <>
            <g key={key}>
              <animated.path
                // compute interpolated path d attribute from intermediate angle values
                d={to(
                  [props.startAngle, props.endAngle],
                  (startAngle, endAngle) => path({
                    ...arc,
                    startAngle,
                    endAngle,
                  }),
                )}
                fill={getColor(arc)}
                onClick={onClickDatum ? () => onClickDatum(arc) : null}
                onTouchStart={onClickDatum ? () => onClickDatum(arc) : null}
                onPointerMove={showTooltip}
                onMouseOver={showTooltip}
                onMouseOut={hideTooltip}
                onBlur={hideTooltip}
                data-tooltip={tooltip}
                onFocus={showTooltip}
                style={{
                  cursor: onClickDatum ? 'pointer' : undefined,
                }}
              />
              {hasSpaceForLabel && showLabel && (
                <animated.g style={{ opacity: props.opacity }}>
                  <text
                    fill={theme.palette.common.white}
                    x={centroidX}
                    y={centroidY}
                    dy=".33em"
                    fontSize="0.75em"
                    textAnchor="middle"
                    pointerEvents="none"
                    style={{
                      textShadow: '#000 0px 0 10px',
                    }}
                  >
                    {getKey(arc)}
                  </text>
                </animated.g>
              )}
            </g>
          </>
        );
      })}
    </>
  );
}
